import AdjustLeaveModal from "@/models/AdjustLeave";

const GET_FACE_USER_PAGING_LIST = 'GET_FACE_USER_PAGING_LIST';
const UPDATE_INVITE_USERS = 'UPDATE_INVITE_USERS';
const SUBMIT_FACE_DATA = 'SUBMIT_FACE_DATA';
const UPDATE_FACE_DETECT = 'UPDATE_FACE_DETECT';
const GET_USER_FACE_STATUS = 'GET_USER_FACE_STATUS';
const UPLOAD_FACE_IMG = 'UPLOAD_FACE_IMG';
const GET_FACE_NEW_USER_INFO = 'GET_FACE_NEW_USER_INFO';

// 获取人脸录制邀请列表
async function getFaceUserPagingList(params) {
  const payload = await new AdjustLeaveModal().getFaceUserPagingList(params);
  return {
    type: GET_FACE_USER_PAGING_LIST,
    payload
  };
}

// 邀请用户录入人脸
async function updateInviteUsers(params) {
  const payload = await new AdjustLeaveModal().updateInviteUsers(params);
  return {
    type: UPDATE_INVITE_USERS,
    payload
  };
}

// 提交人脸数据
async function submitFaceData(params) {
  const payload = await new AdjustLeaveModal().submitFaceData(params);
  return {
    type: SUBMIT_FACE_DATA,
    payload
  };
}

// 进行照片合规评分
async function updateFaceDetect(params) {
  const payload = await new AdjustLeaveModal().updateFaceDetect(params);
  return {
    type: UPDATE_FACE_DETECT,
    payload
  };
}

// 查询人脸数据状态
async function getUserFaceStatus(params) {
  const payload = await new AdjustLeaveModal().getUserFaceStatus(params);
  return {
    type: GET_USER_FACE_STATUS,
    payload
  };
}

// 查询人脸数据状态
async function uploadFaceImg(params) {
  const payload = await new AdjustLeaveModal().uplodeFaceImg(params);
  return {
    type: UPLOAD_FACE_IMG,
    payload
  };
}

// 查询新员工数据
async function getFaceNewUserInfo(params) {
  const payload = await new AdjustLeaveModal().getFaceNewUserInfo(params);
  return {
    type: GET_FACE_NEW_USER_INFO,
    payload
  };
}

const ACTION_TYPES = {
  GET_FACE_USER_PAGING_LIST,
  UPDATE_INVITE_USERS,
  SUBMIT_FACE_DATA,
  UPDATE_FACE_DETECT,
  GET_USER_FACE_STATUS,
  UPLOAD_FACE_IMG,
  GET_FACE_NEW_USER_INFO,
};

const ACTION = {
  getFaceUserPagingList,
  updateInviteUsers,
  submitFaceData,
  updateFaceDetect,
  getUserFaceStatus,
  uploadFaceImg,
  getFaceNewUserInfo,
};

const FaceRegister = {
  ACTION_TYPES,
  ACTION
}

export default FaceRegister;